// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__3xaJM","center":"Button_center__1gD40","ripple":"Button_ripple__1ELLt","rippleContainer":"Button_rippleContainer__2QERV"};